import { createFileRoute } from '@tanstack/react-router'

interface IDayCardsSearch {
  search?: string
}

export const Route = createFileRoute('/_authenticated/companies_/$companyId/day-cards')({
  validateSearch: (search: Record<string, unknown>): IDayCardsSearch => ({
    search: typeof search.search === 'string' ? search.search : undefined,
  }),
})
